import classNames from "classnames";
import {
  AboutGridItem,
  FeaturedWorkImages,
  FeaturedWorkImagesLayoutType,
  ImageType,
} from "module/types";
import React from "react";
import { useTranslation } from "react-i18next";
import "sass/components/ModalPage.scss";

type ModalPageProps = {
  aboutItem: AboutGridItem;
  images: FeaturedWorkImages;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
};

function ModalPage({ aboutItem, images, onClick }: ModalPageProps) {
  const { t } = useTranslation();
  const youtubePrefix = "https://youtube.com/embed/";

  const renderThumbnail = () => (
    <img className="modal-page-thumbnail" alt="" src={images.thumbnail.url} />
  );

  const renderImage = (key: number, url: string, orientation: string = "") => (
    <img
      key={key}
      className={classNames("modal-page-grid-imgs-cell", orientation)}
      alt=""
      src={url}
    />
  );

  const renderDefaultGrid = (includeThumbnail: boolean) => {
    return (
      <>
        {!includeThumbnail && renderThumbnail()}
        {images.images.length > 0 && (
          <div className="modal-page-grid-imgs">
            {includeThumbnail && renderImage(-1, images.thumbnail.url)}
            {images.images.map((item, index) => renderImage(index, item.url))}
          </div>
        )}
      </>
    );
  };

  const renderMixGrid = (includeThumbnail: boolean) => {
    return (
      <>
        {!includeThumbnail && renderThumbnail()}
        <div className={"modal-page-grid-imgs-mix-container"}>
          {includeThumbnail
            ? renderFilteredImageGrid(
                [images.thumbnail, ...images.images],
                "horizontal"
              )
            : renderFilteredImageGrid(images.images, "horizontal")}
          {renderFilteredImageGrid(images.images, "vertical")}
        </div>
      </>
    );
  };

  const renderFilteredImageGrid = (
    imageTypes: ImageType[],
    orientation: "horizontal" | "vertical"
  ) => (
    <div className={classNames("modal-page-grid-imgs", orientation)}>
      {imageTypes
        .filter((item) => item.orientation === orientation)
        .map((item, index) => renderImage(index, item.url, orientation))}
    </div>
  );

  return (
    <div className="modal-page-bg" onClick={onClick}>
      <div
        className={classNames("modal-page-container", "")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {aboutItem.layoutType === FeaturedWorkImagesLayoutType.mix ||
        aboutItem.layoutType ===
          FeaturedWorkImagesLayoutType.include_thumbnail_mix ? (
          <>
            {renderMixGrid(
              aboutItem.layoutType ===
                FeaturedWorkImagesLayoutType.include_thumbnail_mix
            )}
          </>
        ) : (
          renderDefaultGrid(
            aboutItem.layoutType ===
              FeaturedWorkImagesLayoutType.include_thumbnail
          )
        )}
        {aboutItem.videos.length > 0 && (
          <div className="modal-page-grid-videos">
            {aboutItem.videos.map((url, index) => (
              <iframe
                key={index}
                className={classNames("modal-video", {
                  "full-width":
                    aboutItem.videos.length % 2 === 1 && index === 0,
                })}
                title="youtube"
                id="player"
                src={youtubePrefix + url}
                allowFullScreen
              />
            ))}
          </div>
        )}
        <div className="modal-page-title">
          {t(`featuredWorks.${aboutItem.imageKey}.title`)}
        </div>
        <div className="modal-page-description">
          {t(`featuredWorks.${aboutItem.imageKey}.description`)}
        </div>
      </div>
    </div>
  );
}

export default ModalPage;
